import { supabase } from "@/integrations/supabase/client";
import type { TemplateName, TemplatePropsMap } from "@/emails/registry";

export interface SendEmailArgs<T extends TemplateName> {
  template: T;
  to: string;
  props: TemplatePropsMap[T];
  category?: "transactional" | "marketing";
  from?: string;
}

export interface SendEmailResult {
  ok: boolean;
  email_id?: string;
  resend_id?: string | null;
  reason?: string;
  error?: string;
}

/** Fire-and-forget-friendly client wrapper around the send-email Edge Function. */
export async function sendEmail<T extends TemplateName>(args: SendEmailArgs<T>): Promise<SendEmailResult> {
  try {
    const { data, error } = await supabase.functions.invoke("send-email", {
      body: {
        template_name: args.template,
        to: args.to,
        props: args.props,
        category: args.category ?? "transactional",
        from: args.from,
      },
    });
    if (error) {
      console.error("[sendEmail] invoke error", error);
      return { ok: false, error: error.message };
    }
    return data as SendEmailResult;
  } catch (e) {
    console.error("[sendEmail] unexpected error", e);
    return { ok: false, error: e instanceof Error ? e.message : "Unknown error" };
  }
}